// exaustores.jsx
// Configuração dos exaustores

export const exaustoresConfig = [
  { 
    id: "exaustor01", 
    modulo: "17", 
    idx: "1", 
    descricao: "Exaustor APTOS Final 01"
  },
  { 
    id: "exaustor02", 
    modulo: "17", 
    idx: "2", 
    descricao: "Exaustor APTOS Final 02"
  },
  { 
    id: "exaustor03", 
    modulo: "17", 
    idx: "3", 
    descricao: "Exaustor APTOS Final 03"
  },
  { 
    id: "exaustor04", 
    modulo: "17", 
    idx: "4", 
    descricao: "Exaustor APTOS Final 04"
  }
];

// Função útil para obter informações de ON/OFF para cada exaustor
export const getExaustorOnOffValues = (exaustorId) => {
  const exaustor = exaustoresConfig.find(ex => ex.id === exaustorId || ex.descricao === exaustorId);
  if (!exaustor) {
    return null;
  }
  
  return {
    descricao: exaustor.descricao,
    onValue: JSON.stringify({ modulo: exaustor.modulo, idx: exaustor.idx, status: "ON" }),
    offValue: JSON.stringify({ modulo: exaustor.modulo, idx: exaustor.idx, status: "OFF" })
  };
};